export default __webpack_public_path__ + "static/media/foliage-olive-branch-3@2x.acb30e31.png";